import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MyserviceService } from '../myservice.service';
import { saveAs } from "file-saver";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-multiple-file-download',
  templateUrl: './multiple-file-download.component.html',
  styleUrls: ['./multiple-file-download.component.css'],
  providers: [MessageService,DatePipe]
})
export class MultipleFileDownloadComponent implements OnInit {
  @Input('displayPostTransDownload') displayPostTransDownload;
  @Input('mulPostTransData') mulPostTransData;
  @Input('instanceId') instanceId;
  @Output() updateMultiFileShowDialog: EventEmitter<string> = new EventEmitter<string>();
  @Output() updateloaderVisibilty: EventEmitter<string> = new EventEmitter<string>();
  disableDownload: boolean;
  constructor(private messageService: MessageService,
    public datepipe: DatePipe,
    private apiService: MyserviceService,) { }

  ngOnInit() {
  }
  downloadMultiPostTransFiles() {
    let selectedFiles = []
    this.disableDownload = true;
    let selected = false;
    //user should select atleast one file
    this.mulPostTransData.every((file) => {
      if (file.isSelected == true) {
        selected = true;
        return false;
      }
      else {
        return true;
      }
    })
    if (selected == false) {
      this.messageService.add({
        severity: "error",
        detail: "Please choose atleast one file",
      });
    } else {
      var date = new Date()
      this.displayPostTransDownload = false;
      this.updateloaderVisibilty.emit("true")
      this.mulPostTransData.map((data) => {
        if (data.isSelected) {
          selectedFiles.push(data.path)
        }
      })
      this.apiService.multiFileDownload(selectedFiles.join(',')).subscribe((response: any) => {
        this.updateloaderVisibilty.emit("false")
        let blob = new Blob([response], { type: "octet/stream" });
        saveAs(blob, `Post_trans_file_${this.instanceId}_${this.datepipe.transform(date, "MMddyyyy_HHmm")}.zip`);
      });
    }
    this.disableDownload = false;
  }
  updateShoW() {
    this.updateMultiFileShowDialog.emit("false")
  }
}
